import React from 'react';
import styled from 'styled-components/macro';
import { useSelector } from 'src/client/redux';

export const HeaderStrip = () => {
  const site = useSelector((state) => state.site);
  const { config, cdnUrl } = useSelector((state) => state.app);

  if (!config.headerBar?.showHeaderStrip) {
    return null;
  }

  return <StyledHeaderStrip path={`${cdnUrl}/headerStrips/${site.abbreviation}.png`} />;
};

const StyledHeaderStrip = styled.div<{ path: string }>`
  background-image: url(${(props) => props.path});
  background-repeat: repeat-x;
  height: 9px;
  width: 100%;
`;
